import { schema } from 'normalizr';

export class Tag {
  name: string;
}

export const tagSchema = new schema.Entity('tags', {}, {idAttribute: 'name' +
  ''});
